import { CartItemType } from "../../services/redux/types/CartLoyaltyV2Types";
import LoyaltyOffer from "../LoyaltyOfferClass/LoyaltyOffer";
import Offer from "../OfferClass/Offer/Offer";
import { CartItemStatus } from "../enums";
import { LoyaltyOfferSystem } from "../loyaltyTypes";
import { OFFER_SYSTEM } from "../types";

export function isCartItemCanceled(item: CartItemType): boolean {
  const state = (item as { state?: string }).state;

  return state === CartItemStatus.CANCELED;
}

/** V2 loyalty cart row — offer styling from response line `appliedOffer` or pricing flags. */
export function isLoyaltyOfferLine(item: CartItemType): boolean {
  return !!item.appliedOffer;
}

/** Milestone/pointing-offer styling — legacy uses POINTING_OFFER, loyalty v2 uses MILESTONE. */
export function isCartPointingSystemOffer(args: {
  useLoyaltyService: boolean;
  legacyOffer?: Offer;
  resolvedLoyaltyOffer?: LoyaltyOffer;
}): boolean {
  if (args.useLoyaltyService) {
    return (
      args.resolvedLoyaltyOffer?.offerSystem === LoyaltyOfferSystem.MILESTONE
    );
  }

  return args.legacyOffer?.offerSystem === OFFER_SYSTEM.POINTING_OFFER;
}

/** Legacy cart row offer detection (unchanged). */
export function isLegacyOfferLine(item: CartItemType): boolean {
  return !!(
    item.isFreeItem ||
    item.discountedItemPercentage ||
    item.isOfferItem
  );
}
